;(function () {
  'use strict'

  angular.module('deskfy.core').directive('attachmentListItem', attachmentListItem)

  /* @ngInject */
  function attachmentListItem () {
    return {
      restrict: 'E',
      scope: {
        attachment: '<',
        task: '<',
        hideTogglePrivacy: '<',
        isRelatedTaskAttachment: '<',
        index: '<',
        onRemove: '&',
        onSelect: '&',
        viewMode: '<',
        noInteraction: '<',
        viewActionOnly: '<',
        internalApprovalAsset: '<'
      },
      templateUrl: '/core/directives/attachment-list-item/attachment-list-item-directive.html?$$REVISION$$',
      controller: 'AttachmentListItemController'
    }
  }
})()
